import { SVG, IconProps } from "../SVG";
import React from "react";

export const Venmo = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
        <g clipPath="url(#Venmo_svg__a)">
            <path
                fill="#008CFF"
                fillRule="evenodd"
                d="M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Z"
                clipRule="evenodd"
            />
            <path
                fill="#fff"
                d="M16.494 7.5c.349.6.506 1.219.506 2 0 2.491-2.041 5.727-3.698 8H9.518L8 8.046l3.313-.328.803 6.727c.75-1.272 1.675-3.272 1.675-4.635 0-.747-.123-1.255-.315-1.674l3.018-.636Z"
            />
        </g>
        <defs>
            <clipPath id="Venmo_svg__a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </SVG>
);
Venmo.displayName = "Venmo";
